// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Image_image__TYCtg{display:none;width:auto;height:auto}", "",{"version":3,"sources":["webpack://./src/components/Image/index.module.scss"],"names":[],"mappings":"AAAA,oBACC,YAAA,CACA,UAAA,CACA,WAAA","sourcesContent":[".image {\n\tdisplay: none;\n\twidth: auto;\n\theight: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image": "Image_image__TYCtg"
};
export default ___CSS_LOADER_EXPORT___;
